import axios from 'axios';

// Base URL for server API
const API_URL = process.env.REACT_APP_API_URL || 'https://api.instarizz.me';

// Create axios instance with default config
const authApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // Riportato a true per coerenza con supports_credentials=True del backend
});

// Debug function per log degli errori
const logAuthError = (action, error) => {
  console.error(`Auth ${action} error:`, error);
  if (error.response) {
    console.error('Response status:', error.response.status);
    console.error('Response data:', error.response.data);
  }
  if (error.request) {
    console.error('Request:', error.request);
  }
};

// Register a new user
export const registerUser = async (email, password, name) => {
  try {
    console.log("Registering user at URL:", `${API_URL}/api/auth/register`);
    const response = await axios.post(`${API_URL}/api/auth/register`, { 
      email, 
      password, 
      name 
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });
    
    // Store the token in localStorage
    localStorage.setItem('token', response.data.token);
    
    return response.data.user;
  } catch (error) {
    logAuthError('registration', error);
    throw error;
  }
};

// Login user
export const loginUser = async (email, password) => {
  console.log('Attempting login for:', email);
  console.log("Login URL:", `${API_URL}/api/auth/login`);
  try {
    const response = await axios.post(`${API_URL}/api/auth/login`, { 
      email, 
      password 
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });
    
    console.log('Login response:', response.data);
    
    // Store the token in localStorage
    localStorage.setItem('token', response.data.token);
    
    return response.data.user;
  } catch (error) {
    logAuthError('login', error);
    throw error;
  }
};

// Logout user
export const logoutUser = async () => {
  try {
    await axios.post(`${API_URL}/api/auth/logout`, {}, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });
    localStorage.removeItem('token');
  } catch (error) {
    logAuthError('logout', error);
    // Anche in caso di errore, rimuoviamo il token
    localStorage.removeItem('token');
    throw error;
  }
};

// Get current user's profile
export const getCurrentUser = async () => {
  try {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    if (!token) {
      console.log('No token found in localStorage');
      return null;
    }
    
    console.log('Token found, requesting user profile');
    
    const response = await axios.get(`${API_URL}/api/auth/me`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });
    
    console.log('User profile response:', response.data);
    
    // Restituisci direttamente response.data, poiché l'API restituisce già l'oggetto utente
    return response.data;
  } catch (error) {
    logAuthError('getCurrentUser', error);
    localStorage.removeItem('token'); // Clear invalid token
    return null;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  console.log('isAuthenticated check:', token !== null);
  return token !== null;
};

// Assegna l'oggetto a una variabile prima di esportarlo come default
const authService = {
  registerUser,
  loginUser,
  logoutUser,
  getCurrentUser,
  isAuthenticated
};

export default authService; 